export default __webpack_public_path__ + "static/media/me.ce66af28.jpg";